import { ActionField } from "./action-field";

export class Action {
    name:string = "";
    fields:ActionField[] = [];
    //configFields:any[] = []
}
